import { Fragment } from "react"
import {
    Rating,
    Divider,
    TextField,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton
} from "@mui/material"
import { LocationOn, EventNote, HighlightOff } from "@mui/icons-material"
import { H5, H4, Body2, Body3 } from "../../../../../themes/typography"
import "../../../../../styles/event/EventReview.css"

const image = 'https://images.unsplash.com/photo-1760783318968-273787e0bd30?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzR8fGV2ZW50fGVufDB8MnwwfHx8MA%3D%3D'

export default function EventReview({
    open,
    onClose = () => { },
    onSubmit = () => { },
    eventName = 'Music Concert 2025',
    location = 'Madison Square Garden, New York, NY',
    eventDate = 'Fri 03rd Aug to Sun 05th Aug, 2024',
    eventImage = image
}) {
    return (
        <Fragment>
            <Dialog
                open={open}
                onClose={onClose}
                sx={{
                    '& .MuiPaper-root': {
                        background: 'var(--gradient-blue)',
                        color: 'var(--quaternary-color)',
                        borderRadius: '1rem',
                        border: '1px solid var(--divider-color)',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.5rem',
                        padding: '1rem',
                        maxWidth: 'fit-content',
                        minWidth: '950px'
                    }
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backdropFilter: 'blur(3px)',
                        }
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: '0.5rem',
                        padding: '0rem',
                    }}
                >
                    <div className="event-review-title">
                        <H4 fontWeight={600}>
                            Event Review & Feedback
                        </H4>
                    </div>

                    <IconButton
                        onClick={onClose}
                    >
                        <HighlightOff color="secondary" />
                    </IconButton>
                </DialogTitle>

                <DialogContent
                    dividers={true}
                    sx={{
                        borderTop: '1px solid var(--divider-color)',
                        borderBottom: '1px solid var(--divider-color)',
                        padding: '1rem 0rem'
                    }}
                >
                    <div className="event-review-container">
                        <div className="event-review-wrapper">

                            <div className="event-review-banner">
                                <div className="event-review-banner-img">
                                    <img src={eventImage} alt="Event" />
                                </div>

                                <div className="event-review-banner-content">

                                    <div className="event-review-event-name">
                                        <H4 color="var(--secondary-color)" fontWeight={600}>
                                            {eventName}
                                        </H4>
                                    </div>

                                    <div className="event-review-event-details">

                                        <div className="event-review-event-details-item">
                                            <div className="event-review-detail-icon">
                                                <EventNote color="tertiary" />
                                            </div>
                                            <div className="event-review-detail-value">
                                                <Body2>
                                                    {eventDate}
                                                </Body2>
                                            </div>
                                        </div>

                                        <div className="event-review-event-details-item">
                                            <div className="event-review-detail-icon">
                                                <LocationOn color="tertiary" />
                                            </div>
                                            <div className="event-review-detail-value">
                                                <Body2>
                                                    {location}
                                                </Body2>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>

                            <div className="event-review-inputs-container">

                                <div className="event-review-overall-ratings-container">
                                    <div className="event-review-overall-ratings-title">
                                        <H5 color="var(--secondary-color)">
                                            Overall Rating
                                        </H5>
                                        <Body3>
                                            Rate your overall experience
                                        </Body3>
                                    </div>

                                    <div className="event-review-overall-ratings-inputs">
                                        <Rating
                                            name="overall-rating"
                                            value={0}
                                            max={5}
                                            precision={0.25}
                                            size="large"
                                            sx={{
                                                fontSize: '2rem',
                                                color: 'var(--secondary-color)',
                                                '& .MuiRating-icon': {
                                                    color: 'var(--secondary-color)'
                                                }
                                            }}
                                        />
                                    </div>
                                </div>

                                <Divider
                                    sx={{
                                        borderColor: 'var(--divider-color)',
                                        alignSelf: 'stretch'
                                    }}
                                />

                                <div className="event-review-share-experience-container">
                                    <div className="event-review-share-experience-title">
                                        <H5 color="var(--secondary-color)">
                                            Share your experience
                                        </H5>
                                        <Body3>
                                            Tell us what you loved and what could be improved
                                        </Body3>
                                    </div>

                                    <div className="event-review-share-experience-inputs">
                                        <TextField
                                            multiline
                                            rows={4}
                                            fullWidth
                                            placeholder="Your detailed feedback helps us create a better events. Share your favorite moments, suggestions, and any other concerns."
                                        />
                                    </div>
                                </div>

                            </div>

                            {/* <div className="submit-event-review-form-container">

                                <div className="submit-event-review-form-button">
                                    <Button variant="main">
                                        Submit Review
                                    </Button>
                                </div>

                                <div className="submit-event-review-form-greeting">
                                    <Body3>
                                        Your feedback is confidential and helps us improve future events.
                                    </Body3>
                                </div>
                            </div> */}

                        </div>
                    </div>
                </DialogContent>

                <DialogActions
                    sx={{
                        padding: '0'
                    }}
                >
                    <Button
                        variant="main"
                        onClick={onSubmit}
                    >
                        Submit Review
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    )
}